import { useInView } from "react-intersection-observer";
import ItemCard from "./ItemCard";
import { useEffect, useState } from "react";
import { loadImage } from "../../services/DataService";
import {
  getCardsLogoUrl,
  isCardsLogoRaster,
} from "../../services/cardsLogoMap";

export const LazyItemCard = ({ item, selectedMode, ...props }) => {
  const [loadedImages, setLoadedImages] = useState({});

  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true, // Load each image only once
  });

  useEffect(() => {
    if (!inView || item._id == null) return;
    if (item._id in loadedImages) return;
    loadImage(item).then((img) => {
      setLoadedImages((prev) => ({
        ...prev,
        [item._id]: img,
      }));
    });
  }, [inView, item, loadImage, loadedImages]);
  const bundleLogoUrl =
    item._source === "csv" && item.img ? getCardsLogoUrl(item.img) : null;
  const bundledLogoIsWebp =
    item._source === "csv" && item.img ? isCardsLogoRaster(item.img) : false;

  return (
    <div ref={ref}>
      <ItemCard
        data={{
          ...item,
          image: loadedImages[item._id] || item.image,
          category: selectedMode,
        }}
        imageUrl={bundleLogoUrl || undefined}
        bundledLogoIsWebp={bundledLogoIsWebp}
        selectedMode={selectedMode}
        {...props}
      />
    </div>
  );
};
